module.exports = __webpack_public_path__ + "static/media/reqruiter.8a504ecb.svg";